import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, formatDate } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.CorteIngresosZEDto;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Desde", cell: x => ({ data: formatDate(x.FechaDesde) }) },
    { title: "Hasta", cell: x => ({ data: formatDate(x.FechaCorte) }) }
];

export interface BotonesListaDeps {
    //onImprimir: (x: Entity) => void;
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesListaDeps): Column[] {
    const botones = kea.columnaBotones([
        // { onClick: deps.onImprimir, tooltip: "imprimir reporte al corte", iconClass: fa("file-excel-o") }
    ]);
    return [botones, ...columnasFijas];
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/corteingresosZE/list/columns.tsx